import Splide from '@splidejs/splide';

let downloadSlides = document.getElementsByClassName('download-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < downloadSlides.length; i++) {
        let splide = new Splide(downloadSlides[i], {
            type: 'slide',
            perMove: 1,
            perPage: 3,
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%',
            gap: 38,
            breakpoints: {
                1440: {
                    perPage: 2,
                },
                640: {
                    perPage: 1,
                    gap: 16,
                },
            }
        });

        let bar = splide.root.querySelector('.splide-progress-bar');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.on('mounted', function () {
            let track = splide.root.querySelector('.splide__track');
            track.classList.add('hasOverflow');

            let total = splide.length;
            let progress = splide.root.querySelector('.progress');

            if (total < 4) {
                progress.classList.add('hide-for-xxxlarge');
            }
        });

        splide.mount();
    }
});
